import { ScopeTypes } from "./dashboard";

type TSimpleReview = {
  id: number;
  period_start: string;
  period_end: string;
};

enum TReviewSharingStatus {
  private = "private",
  public = "public",
  turnoverHidden = "turnover_hidden",
}

type TReviewCommunicateResponse = {
  id: number;
  sharing_status: TReviewSharingStatus;
  public_review_url?: string;
  hide_comparison: boolean;
  hide_economic_intensity: boolean;
  hide_spending: boolean;
  scopes_ghg_url?: string;
  scopes_beges_url?: string;
  trajectories_url?: string;
  emission_factors_url?: string;
  company_with_subsidiaries?: boolean;
  has_other_reviews_at_same_date?: boolean;
  score: {
    is_external?: boolean;
  };
  calculated_scopes: Record<ScopeTypes, boolean>;
};

type TExportUrls = {
  emission_factors_url?: string;
  scopes_beges_url?: string;
  scopes_ghg_url?: string;
  product_materials_url?: string;
};

type TMedalData = {
  id: number;
  rating: number;
  medal: "diamond" | "gold" | "silver" | "bronze" | null;
  season: string;
  year: number;
  any_medals?: boolean;
};

export type {
  TExportUrls,
  TMedalData,
  TReviewCommunicateResponse,
  TSimpleReview,
};
export { TReviewSharingStatus };
